import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import { Provider } from 'react-redux';
import configureStore from '../../../../redux/configureStore';
import DocketDetailsPurchaseForm from './DocketDetailsPurchaseForm';

storiesOf('Docket/Popups/DocketDetailsPurchaseForm', module).add('View', () => [
  <h3>Step 1</h3>,
  <p>First, we look at price of all dockets</p>,
  <DocketDetailsPurchaseForm
    docketParts={{
      parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
      percentage: 57, // Current Step percent complete
      step: 1, // Current Step number
      status: 'loading', // loading, done
    }}
    buy={action('Buy')}
    showXfaWarning
  />,
  <hr />,
  <h3>Step 1b</h3>,
  <p>We show price for downloads, and user has to click to proceed</p>,
  <Provider store={configureStore()}>
    <DocketDetailsPurchaseForm
      docketParts={{
        partsToPurchase: 18, // Number of parts that need purchasing, can be greater than number of dockets
        totalParts: 27, // Total number of parts that will be bundled.
        totalCost: 12.4, // Total cost for all purchases
        parts: [1, 2, 3, 4, 5], // List of input Docket numbers ?
        percentage: 99, // Current Step percent complete
        step: 1, // Current Step number
        status: 'done', // loading, done
      }}
      buy={action('Buy')}
      showXfaWarning
    />
  </Provider>,
  <hr />,
  <h3>Step 2</h3>,
  <p>Then, we buy all the dockets</p>,
  <DocketDetailsPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      // totalCost: 12.40,       // Total cost for all purchases
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 2,
      status: 'loading',
      alreadyPurchased: false, // If there was no purchases to be made for step 2
    }}
    buy={action('Buy')}
    showXfaWarning
  />,
  <hr />,
  <h3>Step 2 - Error</h3>,
  <p>If an error occurred purchasing, the dialog shows the error</p>,
  <DocketDetailsPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      // totalCost: 12.40,       // Total cost for all purchases
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 2,
      status: 'done',
      errors: ['No PACER Credentials for uid 123.'],
      alreadyPurchased: false, // If there was no purchases to be made for step 2
    }}
    buy={action('Buy')}
    showXfaWarning
  />,
  <hr />,
  <h3>Step 3</h3>,
  <p>Lastly we do some combining</p>,
  <DocketDetailsPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 3,
      status: 'loading',
      purchased: 7, // Number of parts purchased for step 2
      alreadyPurchased: false, // If there was no purchases to be made for step 2
    }}
    buy={action('Buy')}
    showXfaWarning
  />,
  <hr />,
  <h3>Final Message</h3>,
  <p>In the end, we can show a link for download</p>,
  <DocketDetailsPurchaseForm
    docketParts={{
      totalParts: 27, // Total number of parts that will be bundled.
      partsToPurchase: 7, // Number of parts that need purchasing, can be greater than number of dockets
      parts: [1, 2, 3, 4, 5],
      percentage: 17,
      step: 3,
      status: 'done',
      purchased: 7, // Number of parts purchased for step 2
      alreadyPurchased: false, // If there was no purchases to be made for step 2
      link: 'http://link-to-download',
    }}
    buy={action('Buy')}
    showXfaWarning
  />,
]);



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/DocketDetailsPurchaseForm.stories.jsx